import { createContext, useContext, useEffect, useState } from 'react';
import { makeProvider } from '../../helpers/makeContexts';

const initDashModalStore = {
  openModals: [], //an array of modal names that should be open, i.e. ['dashName']
  movingCardToNewContainerInfo: {
    isMovingCardToNewContainer: false, //a flag to indicate if the user is moving a card to a new container
    moveCardInfo: {}, //an object to store the information of the card that is being moved
    updatedOringinCoantainer: {}, //an object to store the updated information of the origin container
  },
};

function reducer(draft, { type, payload }) {
  switch (type) {
    case 'openModal': {
      if (draft.openModals.indexOf(payload) === -1) {
        draft.openModals.push(payload);
      }
      break;
    }
    case 'closeModal': {
      let index = draft.openModals.indexOf(payload);
      if (index !== -1) {
        draft.openModals.splice(index, 1);
      }
      break;
    }
    case 'setMovingCardToNewContainerInfo': {
      draft.movingCardToNewContainerInfo = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [Context, Dispatch] = [createContext(null), createContext(null)];

export const DashboardModalProvider = makeProvider(
  Context,
  Dispatch,
  reducer,
  initDashModalStore
);

export function useDashboardModalDispatch() {
  return useContext(Dispatch);
}

export function useDashboardModalStore() {
  return useContext(Context);
}

// use this hook in a component that is only for rendering the modal as it will cause the component to rerender on every modal change
export function useDashboardModal(modalName) {
  const [open, setOpen] = useState(false);
  const { openModals } = useContext(Context);
  const dispatch = useDashboardModalDispatch();

  function setStatus(status) {
    if (status) {
      dispatch({ type: 'openModal', payload: modalName });
    } else {
      dispatch({ type: 'closeModal', payload: modalName });
    }
  }

  useEffect(() => {
    let index = openModals.indexOf(modalName);
    if (index === -1) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [openModals]);

  return [open, setStatus];
}
